export type SurveyRendererProps = {
  model: unknown;
};

export const areSurveyRendererPropsEqual = (
  previous: SurveyRendererProps,
  next: SurveyRendererProps,
): boolean => previous.model === next.model;
